// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CidrBlock
 */
export interface CidrBlock {
  /**
   * +kubebuilder:validation:Pattern="^((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))$"
   * IP Address
   * @type {string}
   * @memberof CidrBlock
   */
  ipAddress?: string;
  /**
   * +kubebuilder:validation:Minimum=0
   * +kubebuilder:validation:Maximum=32
   * Prefix Length
   * @type {number}
   * @memberof CidrBlock
   */
  prefixLen?: number;
}

/**
 * Check if a given object implements the CidrBlock interface.
 */
export function instanceOfCidrBlock(value: object): value is CidrBlock {
  return true;
}

export function CidrBlockFromJSON(json: any): CidrBlock {
  return CidrBlockFromJSONTyped(json, false);
}

export function CidrBlockFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CidrBlock {
  if (json == null) {
    return json;
  }
  return {
    ipAddress: json['ipAddress'] == null ? undefined : json['ipAddress'],
    prefixLen: json['prefixLen'] == null ? undefined : json['prefixLen'],
  };
}

export function CidrBlockToJSON(json: any): CidrBlock {
  return CidrBlockToJSONTyped(json, false);
}

export function CidrBlockToJSONTyped(
  value?: CidrBlock | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    ipAddress: value['ipAddress'],
    prefixLen: value['prefixLen'],
  };
}
